// RFC 9457 problems as the frontend sees them. The API's `type` is `<base>/<slug>`; screens decide on the slug, never on
// free text (ERROR_CATALOG.md). `title` is already user-facing Spanish.

export interface ProblemField {
  readonly pointer: string;
  readonly detail: string;
}

export class ApiProblem extends Error {
  constructor(
    readonly status: number,
    readonly slug: string,
    readonly title: string,
    readonly detail?: string,
    readonly errors: readonly ProblemField[] = [],
    readonly retryAfterSeconds?: number,
  ) {
    super(title);
    this.name = 'ApiProblem';
  }

  /** Field errors keyed by the last JSON Pointer segment ("#/newPassword" ⇒ "newPassword"). */
  fieldErrors(): Record<string, string> {
    const byField: Record<string, string> = {};
    for (const error of this.errors) {
      const field = error.pointer.split('/').at(-1) ?? '';
      if (field !== '' && field !== '#' && byField[field] === undefined) byField[field] = error.detail;
    }
    return byField;
  }
}

/** Network failure (no HTTP response): shown as "sin conexión", always retryable by the user. */
export const NETWORK_PROBLEM_SLUG = 'sin-conexion';

export function isProblem(error: unknown, slug?: string): error is ApiProblem {
  return error instanceof ApiProblem && (slug === undefined || error.slug === slug);
}

export function slugOf(type: unknown): string {
  if (typeof type !== 'string') return 'error-desconocido';
  if (type === 'about:blank') return 'error-interno';
  return (
    type
      .split('/')
      .filter((part) => part !== '')
      .at(-1) ?? 'error-desconocido'
  );
}
